interface MediaItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const mediaItems: MediaItem[] = [
  {
    id: 1,
    title: '热血巅峰之作：年度必看Top10',
    desc: '盘点2026年最值得追的热血漫画，从经典到新锐，每一部都让人欲罢不能。下拉式阅读让你一口气追完整季。',
    tag: '编辑精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20style%20illustration%2C%20epic%20battle%20scene%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20amber%20accents%2C%20watercolor%20ink%20artistic%20style%2C%20powerful%20composition%2C%20soft%20background%20with%20gentle%20gradients%2C%20editorial%20quality%2C%20high%20detail%2C%20Japanese%20manga%20aesthetic&width=800&height=500&seq=media-manga-01&orientation=landscape',
    imageAlt: '香香漫画 - 热血漫画精选推荐',
  },
  {
    id: 2,
    title: '恋爱漫画特辑：甜到心里的故事',
    desc: '精选最受欢迎的校园恋爱漫画，从青梅竹马到命运邂逅，每一段感情都值得被认真对待。',
    tag: '人气推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20style%20illustration%2C%20cherry%20blossom%20scene%20with%20two%20characters%20under%20soft%20pink%20light%2C%20warm%20coral%20rose%20tones%2C%20gentle%20watercolor%20artistic%20style%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20editorial%20quality%2C%20high%20detail%2C%20shojo%20manga%20aesthetic&width=800&height=500&seq=media-manga-02&orientation=landscape',
    imageAlt: '香香漫画 - 恋爱漫画精选推荐',
  },
  {
    id: 3,
    title: '悬疑烧脑：高智商漫画推荐',
    desc: '扣人心弦的悬疑推理漫画合集，层层反转让你猜不到结局。下拉阅读沉浸感加倍，根本停不下来。',
    tag: '口碑佳作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20style%20illustration%2C%20dark%20atmospheric%20scene%20with%20dramatic%20shadows%20and%20warm%20golden%20light%20accents%2C%20watercolor%20ink%20artistic%20style%2C%20suspenseful%20composition%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20soft%20gradient%20background%2C%20editorial%20quality%2C%20high%20detail%2C%20seinen%20manga%20aesthetic&width=800&height=500&seq=media-manga-03&orientation=landscape',
    imageAlt: '香香漫画 - 悬疑推理漫画精选推荐',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">编辑团队为你精选必看好漫画</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full aspect-[16/10] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer">
                  查看详情 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}